<app-core-menu></app-core-menu>